export const buildDate: string = "03/11/2026 à 20:50";
export const appState: number = 1;
export const appVersion: string = "0.1.0";
export const appCommit: string = "inconnu";
